import { FACILITY_SHIFT } from '../actionTypes'

const initialState = {
  data: [],
  total: 0,
  params: { limit: 10, offset: 0, page: 1 },
  loading: false,
  error: null,
  success: null,
  selectedShift: null
}

const facilityShiftReducer = (state = initialState, action) => {
  switch (action.type) {
    case FACILITY_SHIFT.LIST_REQUEST:
      return { ...state, loading: true, error: null }
    case FACILITY_SHIFT.LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data,
        total: action.total,
        params: action.params || state.params,
        error: null
      }
    case FACILITY_SHIFT.LIST_FAILURE:
      return { ...state, loading: false, data: [], total: 0, error: action.error }

    case FACILITY_SHIFT.GET_ONE_REQUEST:
      return { ...state, error: null, selectedShift: null }
    case FACILITY_SHIFT.GET_ONE_SUCCESS:
      return { ...state, selectedShift: action.data }
    case FACILITY_SHIFT.GET_ONE_FAILURE:
      return { ...state, selectedShift: null, error: action.error }

    case FACILITY_SHIFT.CREATE_REQUEST:
      return { ...state, loading: true, error: null, success: null }
    case FACILITY_SHIFT.CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [action.data].concat(state.data),
        total: state.total + 1,
        success: 'Successfully created',
        error: null
      }
    case FACILITY_SHIFT.CREATE_FAILURE:
      return { ...state, loading: false, error: action.error, success: null }

    case FACILITY_SHIFT.UPDATE_REQUEST:
      return { ...state, loading: true, error: null, success: null }
    case FACILITY_SHIFT.UPDATE_SUCCESS: {
      const data = state.data.map((item) => {
        return String(item.id) === String(action.data.id) ? action.data : item
      })
      return { ...state, loading: false, data, success: 'Successfully updated', error: null }
    }
    case FACILITY_SHIFT.UPDATE_FAILURE:
      return { ...state, loading: false, error: action.error, success: null }

    case FACILITY_SHIFT.DELETE_REQUEST:
      return { ...state, loading: true, error: null, success: null }
    case FACILITY_SHIFT.DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.filter((item) => String(item.id) !== String(action.id)),
        total: Math.max(0, state.total - 1),
        success: 'Successfully deleted',
        error: null
      }
    case FACILITY_SHIFT.DELETE_FAILURE:
      return { ...state, loading: false, error: action.error, success: null }

    case FACILITY_SHIFT.CLEAR_NOTIFY:
      return { ...state, error: null, success: null }

    default:
      return state
  }
}

export default facilityShiftReducer
